import React from 'react';
import { EditorState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';

interface Prop {
    editorState: EditorState,
};

const NoticeEditor: React.FC<Prop> = (props) => {
    const { editorState } = props;
    return (
        <React.Fragment>
            <Editor
                editorState={editorState}
                localization={{
                    locale: 'ja',
                }}
                toolbar={{
                    options: ['inline', 'blockType', 'fontSize', 'textAlign', 'list', 'colorPicker', 'link', 'remove', 'history'],
                    inline: {
                        options: ['bold', 'italic', 'underline', 'strikethrough', 'monospace']
                    },
                    list: { inDropdown: true },
                    textAlign: { inDropdown: true },
                }}
                stripPastedStyles={true}
                toolbarHidden={true}
                readOnly={true}
            />
        </React.Fragment >
    );
};

export default NoticeEditor;